import {EditableFieldModel} from "@white-label/components/page-builder/models/edit-component.model";
import {FieldType} from "@white-label/components/page-builder/models/model.map";
import {CardModel, CardTypes} from "@white-label/components/page-builder/models/card.model";

export class StatisticsModel {
    stats = new EditableFieldModel('steps', FieldType.array, [
        new OneStatModel(),
        new OneStatModel(),
        new OneStatModel(),
    ], CardModel);
    fieldsMap = [this.stats];

    constructor(data?: {stats?: any}) {
        if(data?.stats){
            this.stats.value = [];
            for(let step of data?.stats.value){
                this.stats.value.push(new OneStatModel(step));
            }
        }
    }
}



export class OneStatModel {
    title = new EditableFieldModel('Title', FieldType.text, 'Users');
    description = new EditableFieldModel('Value', FieldType.text, '11k');
    image = new EditableFieldModel('Any Image', FieldType.image, '');
    fieldsMap = [this.title, this.description, this.image];

    constructor(data?: {image?: any, description?: any, title?: any}) {
        if(data?.title?.value){
            this.title.value = data?.title.value;
        }
        if(data?.description?.value){
            this.description.value = data?.description.value;
        }
        if(data?.image?.value){
            this.image.value = data?.image.value;
        }
    }
}